import React from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useLocation } from 'react-router-dom';
import MuiRouterLink from '€components/MuiRouterLink';
import { Hidden } from '€components/Hidden';
import AboutUsAccordian from './AboutUsAccordian';
import { Routes } from '€lib/routing';

const AboutUs: React.FunctionComponent = () => {
    const { pathname } = useLocation();

    return (
        <Box pl={{ xs: 0, sm: 3 }}>
            <Hidden xsDown>
                <AboutUsAccordian />
            </Hidden>
            <Hidden smUp>
                <Typography variant="overline">About us</Typography>
                <MuiRouterLink
                    to={{
                        pathname: `${Routes.UserPrivacyPolicy}`,
                        state: {
                            path: pathname,
                        },
                    }}
                    underline="none"
                >
                    <Box
                        pl={{ xs: 0, sm: 3 }}
                        py={1.5}
                        display="flex"
                        justifyContent="space-between"
                    >
                        <Typography color="textPrimary" variant="subtitle1">
                            Privacy Policy
                        </Typography>
                        <ChevronRightIcon color="secondary" />
                    </Box>
                    <Divider />
                </MuiRouterLink>
                <MuiRouterLink
                    to={{
                        pathname: `${Routes.UserTermsOfUse}`,
                        state: {
                            path: pathname,
                        },
                    }}
                    underline="none"
                >
                    <Box
                        pl={{ xs: 0, sm: 3 }}
                        py={1.5}
                        display="flex"
                        justifyContent="space-between"
                    >
                        <Typography color="textPrimary" variant="subtitle1">
                            Terms of Use
                        </Typography>
                        <ChevronRightIcon color="secondary" />
                    </Box>
                    <Divider />
                </MuiRouterLink>
            </Hidden>
        </Box>
    );
};

export default AboutUs;
